export const DEFAULT_TEST_ID = 'table-wrapper';
